<div class="item-panel corner">
	<div class="heading"><b>{{brand.fleetSingular}}</b> - {{fleet.fleet_name}}</div>
	<div class="content">
		<div class="row border-between">
			<div class="col-sm-4">
				<div><b>Number of {{brand.assetPlural}}:</b> {{fleet.assets.length}}</div>
				<div *ngIf="!brand.fixedassets && fleet.flight_time"><b>Total {{brand.flightTime}}:</b> {{fleet.flight_time | runtime}}</div>
			</div>
			<div class="col-sm-4">
				<div><b>Remaining Useful Life:</b></div>
				<div *ngIf="fleet.rulmin">{{fleet.rulmin | number : "1.2-2"}} hrs</div>
				<div *ngIf="!fleet.rulmin">No problems detected</div>
			</div>
			<div class="col-sm-4">
				<div class="overall-indicator">
					<div>Overall {{brand.fleetSingular}} Overview</div>
					<app-health-indicator [hi]="fleet.totalhimax"></app-health-indicator>
				</div>
			</div>
		</div>
	</div>
</div>